module.exports = __webpack_public_path__ + "static/img/title_04.190b6ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_04.png
// module id = OqhR
// module chunks = 1